import React from 'react';
import { CheckIcon } from 'lucide-react';
import { modules, productImage } from '../data/content';
export function ModulesSection() {
  return <section className="bg-white px-4 py-6 sm:px-6" aria-labelledby="solution-heading" data-id="element-96" data-mp="1ntd3zo0v457h">
      <div className="mb-3 text-center" data-id="element-97" data-mp="1iw32vb44253t">
        <h2 id="solution-heading" className="mb-1 text-2xl leading-none text-brand-ink sm:text-4xl" data-id="element-98" data-mp="1dwi7tbs2agwd">
          THE SOLUTION YOU'VE BEEN LOOKING FOR
        </h2>
        <p className="mb-1 font-heading text-xs font-semibold uppercase tracking-wide text-brand-red sm:text-sm" data-id="element-99" data-mp="2bjqngq5dsvqg">
          One Complete 6-in-1 Boxing Coaching System
        </p>
        <p className="mb-2 text-xs text-brand-muted sm:text-sm" data-id="element-100" data-mp="21l19v9kipxg0">
          6 Professional Modules In One Complete Operating System
        </p>
        <div className="mb-2 inline-block rounded-lg bg-brand-black px-3 py-1.5 font-heading text-xs font-semibold text-white" data-id="element-101" data-mp="1wpc952wriai4">
          🥊 BOXING COACH PRO™
          <br data-id="element-102" data-mp="l71hqkrwzc3b" />
          <span className="text-brand-gold" data-id="element-103" data-mp="l6hwov6yw7l2">Complete 6-in-1 Operating System</span>
        </div>
        <a href="#pricing" className="mb-2 block" data-id="element-104" data-mp="1ivs1yuuh7j90">
          <img src={productImage} alt="Boxing Coach Pro 6-in-1 system" className="mx-auto w-full max-w-[220px] rounded-xl object-contain shadow-md transition-transform duration-200 hover:scale-[1.02]" data-id="element-105" data-mp="1nuv529qwbfec" />
        </a>
        <p className="text-xs leading-snug text-brand-muted sm:text-sm" data-id="element-106" data-mp="1dy8mjrm1l0fh">
          More than a collection of boxing drills. A complete coaching system designed to help you:
          Plan faster. Organize better sessions. Develop athletes more efficiently. Save hours every
          week.
        </p>
      </div>
      <div className="space-y-2" data-id="element-107" data-mp="q4qfs9sd8nfz">
        {modules.map(module => <article key={module.title} className="flex gap-2.5 rounded-xl border border-black/5 bg-brand-light p-3 shadow-sm" data-id="element-108" data-mp="v663k9lxh822">
            <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-brand-red" data-id="element-109" data-mp="l7q7rtbyham8">
              <CheckIcon className="h-3 w-3 text-white" aria-hidden="true" data-id="element-110" data-mp="2nv6xl7pr87wl" />
            </span>
            <div data-id="element-111" data-mp="2j2dueo9xp7mm">
              <h3 className="mb-0.5 font-heading text-xs font-semibold leading-tight text-brand-ink sm:text-sm" data-id="element-112" data-mp="2j1uefd3ugtb8">
                {module.title}
              </h3>
              <p className="text-[11px] leading-snug text-brand-muted sm:text-xs" data-id="element-113" data-mp="295r95ydp4ek2">
                {module.description}
              </p>
            </div>
          </article>)}
      </div>
    </section>;
}